module.exports = __webpack_public_path__ + "img/P18-zh.2ad86bb9.png";